import classNames from "classnames";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  size: keyof typeof sizes;
  fixed?: boolean;
  animated?: boolean;
};

const sizes = {
  xs: "h-4", // 16px
  sm: "h-5", // 20px
  md: "h-7", // 28px
  lg: "h-8", // 32px
  xl: "h-10", // 40px
  "2xl": "h-11", // 44px
  "3xl": "h-12", // 48px
};

export default function Skeleton({
  size,
  className,
  children,
  fixed = true,
  animated = true,
  ...props
}: Props) {
  return (
    <div
      className={classNames(
        "relative inline-block overflow-hidden rounded-md bg-gray-200",
        fixed
          ? "bg-linear-to-b from-gray-200 to-white bg-fixed"
          : "bg-gray-200",
        sizes[size],
        className,
      )}
      {...props}
    >
      {children}
      {animated && (
        <div className="animate-shimmer absolute inset-0 translate-x-full bg-linear-to-r from-white/0 via-white/50 to-white/0 bg-fixed" />
      )}
    </div>
  );
}
